import * as Sentry from "@sentry/react";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend(event) {
    // Descarta el ruido del script de Netlify RUM (su beacon de analítica falla
    // cuando un bloqueador/red lo corta). No es un bug de la app.
    const frames = event.exception?.values?.[0]?.stacktrace?.frames ?? [];
    const esRuidoNetlifyRum = frames.some(
      (f) =>
        typeof f.filename === "string" &&
        (f.filename.includes("/.netlify/scripts/rum") ||
          f.filename.includes("nsvcs.net")),
    );
    if (esRuidoNetlifyRum) return null;
    return event;
  },
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  );
});
